// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../shared/senses/backgroundImg/ltpSelect10Books.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../shared/organic-fit/backgroundImg/3mustHaveGuides.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#app-sub-root.select-ltp-root-section {
  background: #08080e;
}

#app-sub-root.select-ltp-root-section {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: repeat-y;
  background-size: cover;
  height: auto;
}

#header.header-page-select-ltp {
  display: none;
}

#header.header-page-select-ltp .logo-container {
  margin: 0;
  z-index: 2;
}

.header-page-select-ltp .logo-container {
  justify-content: center;
}

.header-page-select-ltp .logo-container svg path {
  fill: white;
}

.page-select-ltp {
  color: #987f7d;
  padding-bottom: 16px;

  background: top / contain no-repeat
      url(${___CSS_LOADER_URL_REPLACEMENT_1___}),
    linear-gradient(#fef0ee, #fef0ee 68.07%, rgba(253, 253, 255, 0.6));
}

.page-select-ltp .page-header {
  padding-top: 260px;
  padding-top: min(max(34vh, 260px), 300px);

  margin-left: calc(var(--page-side-padding-390) * -1);
  margin-right: calc(var(--page-side-padding-390) * -1);

  color: var(--white);
  font-size: 55px;

  font-style: normal;
  font-weight: 200;
  line-height: normal;
  text-transform: uppercase;
  text-align: center;
}

.page-select-ltp .page-title {
  margin: 0;
  width: 100%;

  color: var(--white);
  font-size: 32px;
  font-style: normal;
  font-weight: 900;
  line-height: 32px; /* 100% */
  text-transform: uppercase;

  text-shadow: 0px 4px 50px rgba(39, 5, 4, 0.2);
}

.page-select-ltp .ltp-logo {
  margin-left: calc(var(--page-side-padding-390) * -1);
  margin-right: calc(var(--page-side-padding-390) * -1);
  position: relative;
}

@media screen and (max-width: 360px) {
  .page-select-ltp .page-header,
  .page-select-ltp .ltp-logo {
    margin-left: calc(var(--page-side-padding-360 * -1));
    margin-right: calc(var(--page-side-padding-360 * -1));
  }
}

.page-select-ltp .ltp-logo img {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.page-select-ltp .single-ltp-block {
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  margin-top: 24px;
}

.page-select-ltp .content-description-title {
  margin: 12px 0 24px;

  color: #987f7d;

  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.page-select-ltp .content-description-title .main {
  font-size: 32px;
  font-weight: 300;
}

.page-select-ltp .content-description-title .secondary {
  font-size: 18px;
  font-weight: 400;
  opacity: 0.6;
  padding: 0 55px;
}

.page-select-ltp .content-description-section {
  --book-height: 51px;
  --background-circle-size: 54px;
  /*size of left and right part of cicle ourside of book image. 34px - width of book image*/
  --circle-remnants: calc((var(--background-circle-size) - 34px) / 2);
}

.page-select-ltp .content-description-section .item {
  width: 100%;
  display: flex;

  padding: 16px 8px 16px calc(8px + var(--circle-remnants));
  border-radius: 16px;
  background: #fff;
  box-shadow: 0px 4px 20px 0px rgba(235, 195, 188, 0.3);
}

.page-select-ltp .content-description-section .icon-node-container {
  position: relative;
  margin-right: calc(var(--circle-remnants) + 12px);

  display: flex;
  align-items: center;
}
.page-select-ltp .content-description-section .icon-node-container img {
  height: var(--book-height);
  z-index: 2;
  position: relative; /* required for z-index  */
}

.page-select-ltp .content-description-section .icon-node-container::before {
  content: '';
  position: absolute;
  top: calc((100% - var(--background-circle-size)) / 2);
  left: calc(50% - var(--background-circle-size) / 2);
  display: inline-block;
  width: var(--background-circle-size);
  height: var(--background-circle-size);
  border-radius: 200px;
  background: rgba(255, 127, 107, 0.1);
  z-index: 1;
}

.page-select-ltp .content-description-section .item + .item {
  margin-top: 10px;
}

.page-select-ltp .content-description-section .text {
  color: #694947;
  font-feature-settings: 'liga' off;
  font-size: 18px;
  font-weight: 800;
  line-height: normal;
}

.page-select-ltp .content-description-section .description {
  margin-top: 4px;

  color: #694947;
  font-feature-settings: 'liga' off;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  opacity: 0.6;
}

.page-select-ltp .select-plan-block-wrapper .btn {
  --button-background-primary: #ff7f6b;

  margin-top: 24px;
  border-radius: 34px;
}

.page-select-ltp .select-plan-block-wrapper .skip {
  text-align: center;
  margin: 16px 0 15px;
}

.page-select-ltp .select-plan-block-wrapper .text-btn {
  text-decoration: none;
  font-size: 16px;
  font-weight: 400;
  color: #a08a8a;
  line-height: normal;
}

.page-select-ltp .payment-disclaimer {
  color: rgba(255, 255, 255, 0.4);
  text-align: center;
  font-size: 11px;
  font-weight: 400;
}

.page-select-ltp .payment-disclaimer .text {
  color: rgba(160, 138, 138, 0.4);

  font-size: 11px;
  font-weight: 400;
  line-height: normal;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/select-ltp.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,yDAAqF;EACrF,2BAA2B;EAC3B,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,oBAAoB;;EAEpB;;sEAEoE;AACtE;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;;EAEzC,oDAAoD;EACpD,qDAAqD;;EAErD,mBAAmB;EACnB,eAAe;;EAEf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;;EAEX,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,yBAAyB;;EAEzB,6CAA6C;AAC/C;;AAEA;EACE,oDAAoD;EACpD,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE;;IAEE,oDAAoD;IACpD,qDAAqD;EACvD;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;;EAEnB,cAAc;;EAEd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,yFAAyF;EACzF,mEAAmE;AACrE;;AAEA;EACE,WAAW;EACX,aAAa;;EAEb,yDAAyD;EACzD,mBAAmB;EACnB,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;;EAEjD,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,UAAU;EACV,kBAAkB,EAAE,0BAA0B;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qDAAqD;EACrD,mDAAmD;EACnD,qBAAqB;EACrB,oCAAoC;EACpC,qCAAqC;EACrC,oBAAoB;EACpB,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;;EAEf,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oCAAoC;;EAEpC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;;EAE/B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":["#app-sub-root.select-ltp-root-section {\n  background: #08080e;\n}\n\n#app-sub-root.select-ltp-root-section {\n  background-image: url('../../../../shared/senses/backgroundImg/ltpSelect10Books.png');\n  background-repeat: repeat-y;\n  background-size: cover;\n  height: auto;\n}\n\n#header.header-page-select-ltp {\n  display: none;\n}\n\n#header.header-page-select-ltp .logo-container {\n  margin: 0;\n  z-index: 2;\n}\n\n.header-page-select-ltp .logo-container {\n  justify-content: center;\n}\n\n.header-page-select-ltp .logo-container svg path {\n  fill: white;\n}\n\n.page-select-ltp {\n  color: #987f7d;\n  padding-bottom: 16px;\n\n  background: top / contain no-repeat\n      url('../../../../shared/organic-fit/backgroundImg/3mustHaveGuides.png'),\n    linear-gradient(#fef0ee, #fef0ee 68.07%, rgba(253, 253, 255, 0.6));\n}\n\n.page-select-ltp .page-header {\n  padding-top: 260px;\n  padding-top: min(max(34vh, 260px), 300px);\n\n  margin-left: calc(var(--page-side-padding-390) * -1);\n  margin-right: calc(var(--page-side-padding-390) * -1);\n\n  color: var(--white);\n  font-size: 55px;\n\n  font-style: normal;\n  font-weight: 200;\n  line-height: normal;\n  text-transform: uppercase;\n  text-align: center;\n}\n\n.page-select-ltp .page-title {\n  margin: 0;\n  width: 100%;\n\n  color: var(--white);\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 900;\n  line-height: 32px; /* 100% */\n  text-transform: uppercase;\n\n  text-shadow: 0px 4px 50px rgba(39, 5, 4, 0.2);\n}\n\n.page-select-ltp .ltp-logo {\n  margin-left: calc(var(--page-side-padding-390) * -1);\n  margin-right: calc(var(--page-side-padding-390) * -1);\n  position: relative;\n}\n\n@media screen and (max-width: 360px) {\n  .page-select-ltp .page-header,\n  .page-select-ltp .ltp-logo {\n    margin-left: calc(var(--page-side-padding-360 * -1));\n    margin-right: calc(var(--page-side-padding-360 * -1));\n  }\n}\n\n.page-select-ltp .ltp-logo img {\n  width: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.page-select-ltp .single-ltp-block {\n  text-align: center;\n  font-size: 18px;\n  font-weight: 400;\n  margin-top: 24px;\n}\n\n.page-select-ltp .content-description-title {\n  margin: 12px 0 24px;\n\n  color: #987f7d;\n\n  text-align: center;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.page-select-ltp .content-description-title .main {\n  font-size: 32px;\n  font-weight: 300;\n}\n\n.page-select-ltp .content-description-title .secondary {\n  font-size: 18px;\n  font-weight: 400;\n  opacity: 0.6;\n  padding: 0 55px;\n}\n\n.page-select-ltp .content-description-section {\n  --book-height: 51px;\n  --background-circle-size: 54px;\n  /*size of left and right part of cicle ourside of book image. 34px - width of book image*/\n  --circle-remnants: calc((var(--background-circle-size) - 34px) / 2);\n}\n\n.page-select-ltp .content-description-section .item {\n  width: 100%;\n  display: flex;\n\n  padding: 16px 8px 16px calc(8px + var(--circle-remnants));\n  border-radius: 16px;\n  background: #fff;\n  box-shadow: 0px 4px 20px 0px rgba(235, 195, 188, 0.3);\n}\n\n.page-select-ltp .content-description-section .icon-node-container {\n  position: relative;\n  margin-right: calc(var(--circle-remnants) + 12px);\n\n  display: flex;\n  align-items: center;\n}\n.page-select-ltp .content-description-section .icon-node-container img {\n  height: var(--book-height);\n  z-index: 2;\n  position: relative; /* required for z-index  */\n}\n\n.page-select-ltp .content-description-section .icon-node-container::before {\n  content: '';\n  position: absolute;\n  top: calc((100% - var(--background-circle-size)) / 2);\n  left: calc(50% - var(--background-circle-size) / 2);\n  display: inline-block;\n  width: var(--background-circle-size);\n  height: var(--background-circle-size);\n  border-radius: 200px;\n  background: rgba(255, 127, 107, 0.1);\n  z-index: 1;\n}\n\n.page-select-ltp .content-description-section .item + .item {\n  margin-top: 10px;\n}\n\n.page-select-ltp .content-description-section .text {\n  color: #694947;\n  font-feature-settings: 'liga' off;\n  font-size: 18px;\n  font-weight: 800;\n  line-height: normal;\n}\n\n.page-select-ltp .content-description-section .description {\n  margin-top: 4px;\n\n  color: #694947;\n  font-feature-settings: 'liga' off;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: normal;\n  opacity: 0.6;\n}\n\n.page-select-ltp .select-plan-block-wrapper .btn {\n  --button-background-primary: #ff7f6b;\n\n  margin-top: 24px;\n  border-radius: 34px;\n}\n\n.page-select-ltp .select-plan-block-wrapper .skip {\n  text-align: center;\n  margin: 16px 0 15px;\n}\n\n.page-select-ltp .select-plan-block-wrapper .text-btn {\n  text-decoration: none;\n  font-size: 16px;\n  font-weight: 400;\n  color: #a08a8a;\n  line-height: normal;\n}\n\n.page-select-ltp .payment-disclaimer {\n  color: rgba(255, 255, 255, 0.4);\n  text-align: center;\n  font-size: 11px;\n  font-weight: 400;\n}\n\n.page-select-ltp .payment-disclaimer .text {\n  color: rgba(160, 138, 138, 0.4);\n\n  font-size: 11px;\n  font-weight: 400;\n  line-height: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
